export default {
  challengerURL: 'https://www.challenger.com.au',
  challengerPhoneNumber: '13 35 66',
  iolURL: '/',
  contactURL: 'https://www.challenger.com.au/about-us/contact-us/enquiry-form',
};
